import React from 'react';
import SupplierItem from './SupplierItem';

const SuppliersList = ({suppliers}) => suppliers.map((supplier, index) => <SupplierItem supplier={supplier} key={index} />);

export default SuppliersList;
